import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { Store, CheckCircle, XCircle } from 'lucide-react';

export default function AcceptInvitation() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('pending'); // pending, processing, success, error, needsAuth
  const [message, setMessage] = useState('');
  const [teamName, setTeamName] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Geçersiz davet linki');
      return;
    }

    // Check if user is logged in
    const authToken = localStorage.getItem('token');
    if (!authToken) {
      setStatus('needsAuth');
      setMessage('Daveti kabul etmek için giriş yapmalısınız');
      return;
    }

    acceptInvitation();
  }, [token]);

  const acceptInvitation = async () => {
    setStatus('processing');
    try {
      const res = await axiosInstance.post(`/invitations/accept?token=${token}`);
      setStatus('success');
      setTeamName(res.data.team.name);
      setMessage(`${res.data.team.name} mağazasına katıldınız!`);
      toast.success('Davet kabul edildi');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Davet kabul edilemedi');
      toast.error('Davet kabul edilemedi');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500 p-4">
      <Card className="w-full max-w-md shadow-2xl border-0 overflow-hidden">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center shadow-lg">
            <Store className="w-10 h-10 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Mağaza Daveti
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          {status === 'pending' && (
            <p className="text-gray-600">Davet kontrol ediliyor...</p>
          )}
          
          {status === 'processing' && (
            <div className="space-y-4">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600 mx-auto"></div>
              <p className="text-gray-600">Davet kabul ediliyor...</p>
            </div>
          )}
          
          {status === 'success' && (
            <div className="space-y-4">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
              <p className="text-lg font-semibold text-gray-800">{message}</p>
              <Button 
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600"
              >
                Mağazaya Git
              </Button>
            </div>
          )}
          
          {status === 'error' && (
            <div className="space-y-4">
              <XCircle className="w-16 h-16 text-red-500 mx-auto" />
              <p className="text-lg font-semibold text-gray-800">{message}</p>
              <Button 
                onClick={() => navigate('/login')}
                variant="outline"
              >
                Giriş Sayfasına Dön
              </Button>
            </div>
          )}
          
          {status === 'needsAuth' && (
            <div className="space-y-4">
              <p className="text-lg font-semibold text-gray-800">{message}</p>
              <div className="flex gap-2 justify-center">
                <Button 
                  onClick={() => navigate(`/login?redirect=/accept-invitation?token=${token}`)}
                  className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600"
                >
                  Giriş Yap
                </Button>
                <Button 
                  onClick={() => navigate(`/register?redirect=/accept-invitation?token=${token}`)}
                  variant="outline"
                >
                  Kayıt Ol
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
